import {
  Button,
  FormControlLabel,
  Grid2,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const RootStyled = styled('div')(() => ({
  padding: 18,
  '@media (min-width: 900px)': {
    padding: 24,
  },
  '@media (min-width: 1200px)': {
    padding: 75,
  },
  '@media (min-width: 1536px)': {
    padding: 110,
  },
}));

export const HeaderModalStyled = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  '@media (max-width: 600px)': {
    '& svg': {
      fontSize: 32,
      marginLeft: -16,
    },
  },
  '& svg': {
    fontSize: 36,
    marginLeft: -16,
  },
}));

export const HeaderTitleStyled = styled(Typography)(() => ({
  margin: '38px 0',
  '@media (max-width: 600px)': {
    fontSize: 28,
  },
}));

export const XYStyled = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: 12,
  '@media (min-width: 900px)': {
    marginTop: 25,
  },
  '@media (max-width: 1200px)': {
    marginTop: 32,
  },
  '@media (min-width: 1536px)': {
    marginTop: 32,
  },
}));

export const InputHeadersStyled = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.global.lightgray,
  fontWeight: 500,
  margin: '12px 0',
  '@media (min-width: 1200px)': {
    fontSize: 16,
  },
}));

export const DeleteButtonStyled = styled(Button)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  cursor: 'pointer',
  color: '#FF0000',
  '& .icon': {
    fontSize: 20,
    marginRight: 10,
  },
});

export const DeleteDivStyled = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: '#FF0000',
  marginTop: -64,
  '& h5': {
    fontWeight: 400,
  },
  '@media (max-width: 600px)': {
    marginTop: 0,
    '& svg': {
      fontSize: 22,
    },
    '& h5': {
      fontSize: 14,
      display: 'none',
    },
  },
  '@media (min-width: 900px)': {
    gap: 8,
    '& svg': {
      fontSize: 20,
    },
  },
}));

export const FormStyled = styled('form')({
  padding: '16px 0',
});

export const CompanyInformationStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const SectionStyled = styled(RadioGroup)(() => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 16,
  gap: 16,
  '@media (min-width: 650px)': {
    flexDirection: 'row',
  },
  '@media (min-width: 900px)': {
    flexDirection: 'row',
  },
  '@media (min-width: 1200px)': {
    flexDirection: 'row',
  },
  '@media (min-width: 1536px)': {
    flexDirection: 'row',
  },
}));

export const RadioButtonStyled = styled(FormControlLabel)({
  maxWidth: '40%',
  marginRight: '20px',
});

export const RadioGroupStyled = styled(RadioGroup)(() => ({
  display: 'flex',
  justifyContent: 'end',
}));

export const NewCategoryInputStyled = styled(Grid2)(() => ({
  gridTemplateRows: '10%',
  gap: 8,
  width: '22%',
  '@media (max-width: 800px)': {
    width: '40%',
  },
  '@media (max-width: 650px)': {
    width: '88%',
  },
}));

export const InputCategoryStyled = styled(TextField)({
  marginRight: 8,
  marginLeft: 8,
  gap: 8,
});

export const BtnSubmitDivStyled = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const BtnSubmitStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.global.white,
  fontWeight: 800,
  height: 40,
  marginTop: 50,
  fontSize: 12,
}));
